module.exports = __webpack_public_path__ + "static/media/caret-right.d7b42ff2.svg";